import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Section.module.css";

type SectionProps = HTMLAttributes<HTMLElement> & {
  id?: string;
  eyebrow?: string;
  title?: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  background?: "default" | "alt" | "brand";
  tight?: boolean;
  children?: ReactNode;
};

export function Section({
  id,
  eyebrow,
  title,
  description,
  align = "left",
  background = "default",
  tight = false,
  className,
  children,
  ...rest
}: SectionProps) {
  const cls = [
    styles.section,
    background === "alt" && styles.altBg,
    background === "brand" && styles.brandBg,
    tight && styles.tight,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const headerCls = [styles.header, align === "center" && styles.headerCenter]
    .filter(Boolean)
    .join(" ");

  return (
    <section id={id} className={cls} {...rest}>
      {(eyebrow || title || description) && (
        <div className={headerCls}>
          {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
          {title && <h2>{title}</h2>}
          {description && <p>{description}</p>}
        </div>
      )}
      {children}
    </section>
  );
}
